import { styled as t } from "@lokalise/styled";
import { spacing as e, typography as o, value as r } from "../../../utils/theme/index.js";
const i = t.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: ${e(0, 1, 2, 1)};
`, p = t.div`
	${o("body.small.strong")};
	color: ${r("color.text.default")};
	cursor: default;
`;
export {
  p as Title,
  i as Wrapper
};
//# sourceMappingURL=styles.js.map
